import React, { useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import {
  Button,
  Grid,
  Input,
  Line,
  Row,
  SelectForm,
  Span,
  PhoneInput,
  InputMask
} from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import {
  IFornecedor,
  SupplierContactsServices
} from 'services/NGT/SupplierRegistration'
import { buscaCep } from 'services/Utils/buscaCep'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'
import { FORMAT } from 'utils'

import { SCHEMA } from '../../../../yup'
import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './SupplierRecordModal.style'
import { useModal } from 'hooks'

interface ISupplierRecordModal {
  showModal: boolean
  toggleModal: () => void
  handleSubmitUpdate: any
  supplierData: IFornecedor
}

const ITS_NOT_LIRYCS_PATTERN = /[^a-zA-z\s]/g

const SupplierRecordModal: React.FC<ISupplierRecordModal> = ({
  showModal,
  toggleModal,
  handleSubmitUpdate,
  supplierData
}) => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState,
    formState: { errors }
  } = useForm<IFornecedor>({
    resolver: yupResolver(SCHEMA.supplierForm)
  })

  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const form = watch()
  const typeSupplier = watch('cdTipoFornecedor')
  const responsibleDoc = watch('cdCpfResponsavel')

  const { showModal: showModalUseModal } = useModal()

  useEffect(() => {
    buscarCep()
  }, [form.cdCep])

  const buscarCep = () => {
    if (form.cdCep?.length === 9) {
      buscaCep(form.cdCep).then(({ data }) => {
        setValue('txEndereco', data?.logradouro)
        setValue('txBairro', data?.bairro)
        setValue('txCidade', data?.localidade)
        setValue('sgEstado', data?.uf)
      })
    }

    if (form.cdCep?.length === 8) {
      buscaCep(
        `${form.cdCep.substring(0, 5)}-${form.cdCep.substring(5, 8)}`
      ).then(({ data }) => {
        setValue('txEndereco', data?.logradouro)
        setValue('txBairro', data?.bairro)
        setValue('txCidade', data?.localidade)
        setValue('sgEstado', data?.uf)
      })
    }

    if (form.cdCep?.length === 0) {
      setValue('txEndereco', '')
      setValue('txBairro', '')
      setValue('txCidade', '')
      setValue('sgEstado', '')
    }
  }

  const [businessContacts, setBusinessContacts] = useState([
    { cdTipo: 'Comercial', idFornecedorContato: 0, nmContato: '', txEmail: '' }
  ])
  const addBusinessContact = () => {
    setBusinessContacts([
      ...businessContacts,
      {
        cdTipo: 'Comercial',
        idFornecedorContato: 0,
        nmContato: '',
        txEmail: ''
      }
    ])
  }
  const removeBusinessContact = (position) => {
    setBusinessContacts([
      ...businessContacts.filter((_, index) => index !== position)
    ])
  }

  const [workContacts, setWorkContacts] = useState([
    {
      cdTipo: 'Trabalhista',
      idFornecedorContato: 0,
      nmContato: '',
      txEmail: ''
    }
  ])
  const addWorkContact = () => {
    setWorkContacts([
      ...workContacts,
      {
        cdTipo: 'Trabalhista',
        idFornecedorContato: 0,
        nmContato: '',
        txEmail: ''
      }
    ])
  }
  const removeWorkContact = (position) => {
    setWorkContacts([...workContacts.filter((_, index) => index !== position)])
  }

  const [securityContacts, setSecurityContacts] = useState([
    { cdTipo: 'Seguranca', idFornecedorContato: 0, nmContato: '', txEmail: '' }
  ])
  const addSecurityContact = () => {
    setSecurityContacts([
      ...securityContacts,
      {
        cdTipo: 'Seguranca',
        idFornecedorContato: 0,
        nmContato: '',
        txEmail: ''
      }
    ])
  }
  const removeSecurityContact = (position) => {
    setSecurityContacts([
      ...securityContacts.filter((_, index) => index !== position)
    ])
  }

  const [importContacts, setImportContacts] = useState([
    {
      cdTipo: 'Importacao',
      idFornecedorContato: 0,
      nmContato: '',
      txEmail: ''
    }
  ])
  const addImportContact = () => {
    setImportContacts([
      ...importContacts,
      {
        cdTipo: 'Importacao',
        idFornecedorContato: 0,
        nmContato: '',
        txEmail: ''
      }
    ])
  }
  const removeImportContact = (position) => {
    setImportContacts([
      ...importContacts.filter((_, index) => index !== position)
    ])
  }

  const [deleteModalOpen, SetDeleteModalOpen] = useState(false)
  const [selectedContact, SetSelectedContact] = useState(0)
  const [selectedType, SetSelectedType] = useState('')
  const [selectedIndex, SetSelectedIndex] = useState(0)

  const resetContactsList = () => {
    businessContacts.splice(0, businessContacts.length)
    workContacts.splice(0, workContacts.length)
    securityContacts.splice(0, securityContacts.length)
    importContacts.splice(0, importContacts.length)
    inicialSetContacts(supplierData)
  }

  const inicialSetContacts = (supplierData) => {
    supplierData?.tFornecedorContatos.map((fornecedorContato) => {
      if (fornecedorContato.cdTipo.trim() === 'Comercial') {
        setBusinessContacts((businessContacts) => [
          ...businessContacts,
          fornecedorContato
        ])
      }
      if (fornecedorContato.cdTipo.trim() === 'Trabalhista') {
        setWorkContacts((workContacts) => [...workContacts, fornecedorContato])
      }
      if (fornecedorContato.cdTipo.trim() === 'Seguranca') {
        setSecurityContacts((securityContacts) => [
          ...securityContacts,
          fornecedorContato
        ])
      }
      if (fornecedorContato.cdTipo.trim() === 'Importacao') {
        setImportContacts((importContacts) => [
          ...importContacts,
          fornecedorContato
        ])
      }
    })
  }

  useEffect(() => {
    resetContactsList()
    reset()
    setValue('cdTipoFornecedor', supplierData?.cdTipoFornecedor)
  }, [supplierData?.cdFornecedor])

  const handleConfirmDeleteContact = (
    id: number,
    index: number,
    contactType: string
  ) => {
    SetDeleteModalOpen(true)
    SetSelectedContact(id)
    SetSelectedType(contactType)
    SetSelectedIndex(index)
  }

  const handleDeleteContact = () => {
    const removeFromState = (contacts) =>
      contacts.filter((_, index) => index !== selectedIndex)

    if (selectedType === 'business') {
      removeBusinessContact(selectedIndex)
      setValue('contatosComercial', removeFromState(businessContacts))
    }
    if (selectedType === 'work') {
      removeWorkContact(selectedIndex)
      setValue('contatosTrabalhista', removeFromState(workContacts))
    }
    if (selectedType === 'security') {
      removeSecurityContact(selectedIndex)
      setValue('contatosSeguranca', removeFromState(securityContacts))
    }
    if (selectedType === 'import') {
      removeImportContact(selectedIndex)
      setValue('contatosImportacao', removeFromState(importContacts))
    }
    SetDeleteModalOpen(false)

    if (selectedContact != 0) {
      setLoading('loading')
      SupplierContactsServices()
        .del(selectedContact)
        .then(() => {
          setLoading('idle')
        })
        .catch((err) => {
          // setMsgErro(err)
          // setLoading('error')
          setLoading('idle')
          showModalUseModal({
            hideButtonCancel: true,
            message: err?.response?.data?.detail,
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
          resetContactsList()
        })
    }
  }

  // Novo handleChange pra parar de repetir mesma lógica
  const handleChange = (contact: any, field: any, e: any, index: number) => {
    const states: any = {
      contatosComercial: [businessContacts, setBusinessContacts],
      contatosImportacao: [importContacts, setImportContacts],
      contatosSeguranca: [securityContacts, setSecurityContacts],
      contatosTrabalhista: [workContacts, setWorkContacts]
    }
    states[contact][0][index][field] = e.target.value
    states[contact][1]([...states[contact][0]])
    setValue(contact, states[contact][0])
  }

  // Diminui a quantidade de ifs pra pegar o erro
  const error = (contact: string, prop: string, index: number) => {
    if (!(errors && errors[contact] && errors[contact][index])) {
      return null
    }
    return errors[contact][index][prop]
  }

  const isValidValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ): boolean => {
    const onlyLetters = null
    const isValid = [onlyLetters].includes(
      event.target.value.match(ITS_NOT_LIRYCS_PATTERN)
    ) as boolean

    return isValid
  }

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={showModal}
      reference={draggableReference}
      onClose={toggleModal}
      width={'xl'}
    >
      <FormDialog
        onSubmit={handleSubmit((data) => {
          handleSubmitUpdate({
            ...data,
            cdFornecedor: supplierData?.cdFornecedor,
            cdFornecedorSap: supplierData?.cdFornecedorSap,
            idFornecedor: supplierData?.idFornecedor,
            tFornecedorContatos: businessContacts.concat(
              securityContacts,
              importContacts,
              workContacts
            )
          })
          resetModalState(draggableReference)
        })}
      >
        <Line />
        <DialogTitleStyled>Consultar / Editar Fornecedor</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="0.6fr 0.6fr 1fr 1fr 3fr 0.8fr 1.2fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
          >
            <Input
              label="Cód. SAP"
              placeholder="Cód. SAP"
              formValue="cdFornecedor"
              value={supplierData?.cdFornecedorSap}
              disabled
            />
            <Input
              label="Cód. Fornecedor"
              placeholder="Cód. Fornecedor"
              formValue="cdFornecedor"
              value={supplierData?.cdFornecedor}
              disabled
            />
            <SelectForm
              marginTop="-3px"
              control={control}
              errors={formState.errors}
              formValue="cdTipoFornecedor"
              label="Tipo"
              listOptions={[
                { label: 'Pessoa Jurídica', value: 'J' },
                { label: 'Pessoa Física', value: 'F' },
                { label: 'Estrangeiro', value: 'E' }
              ]}
              placeholder="Selecione"
              defaultValue={supplierData?.cdTipoFornecedor}
            />
            {typeSupplier === 'J' ? (
              <Input
                control={control}
                errors={errors}
                label="CNPJ"
                placeholder="CNPJ"
                mask={['##.###.###/####-##']}
                formValue="cdDocto"
                defaultValue={supplierData?.cdDocto}
                maxLength={18}
                width="max-content"
              />
            ) : null}
            {typeSupplier === 'F' ? (
              <Input
                control={control}
                errors={errors}
                label="CPF"
                placeholder="CPF"
                mask={['###.###.###-##']}
                formValue="cdDocto"
                defaultValue={supplierData?.cdDocto}
                maxLength={14}
                required
              />
            ) : null}
            {typeSupplier === '' && supplierData?.cdTipoFornecedor === 'J' ? (
              <Input
                control={control}
                errors={errors}
                label="CNPJ"
                placeholder="CNPJ"
                mask={['##.###.###/####-##']}
                formValue="cdDocto"
                defaultValue={supplierData?.cdDocto}
                maxLength={18}
                required
              />
            ) : null}
            {/* {typeSupplier === '' && supplierData?.cdTipoFornecedor === 'E' ? (
              <p></p>
            ) : null} */}
            {typeSupplier === '' && supplierData?.cdTipoFornecedor === 'F' ? (
              <Input
                control={control}
                errors={errors}
                label="CPF"
                placeholder="CPF"
                mask={['###.###.###-##']}
                formValue="cdDocto"
                defaultValue={supplierData?.cdDocto}
                maxLength={14}
                required
              />
            ) : null}
            <Input
              control={control}
              errors={errors}
              label="Fornecedor"
              placeholder="Nome do Fornecedor"
              formValue="nmFornecedor"
              defaultValue={supplierData?.nmFornecedor}
              maxLength={100}
              required
              style={typeSupplier === 'E' ? { width: "481.17px" } : null}
            />
            <Input
              control={control}
              errors={errors}
              label="CEP"
              onChange={() => {
                return //só funciona por conta disso NÃO REMOVER
              }}
              onBlur={buscarCep}
              placeholder="00000-000"
              formValue="cdCep"
              defaultValue={FORMAT.cep(supplierData?.cdCep)}
              mask={['#####-###']}
              maxLength={9}
              style={typeSupplier === 'E' ? { width: "128.31px" } : null}
            />
            <Row
              alignItems="flex-start"
              justifyContent="flex-end"
              marginTop="-4px"
              style={typeSupplier === 'E' ? { width: "144px" } : null}
            >
              {supplierData?.flSap ? (
                <CheckBoxIcon color="primary" />
              ) : (
                <CheckBoxOutlineBlankIcon color={'disabled'} />
              )}
              <Span text="Importado pelo SAP" marginTop="7px" />
            </Row>
          </Grid>

          <Grid
            gridCols="2.5fr 1fr 1fr 2fr 1.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Endereço"
              placeholder="Endereço"
              formValue="txEndereco"
              defaultValue={supplierData?.txEndereco}
              maxLength={50}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Nº do Logradouro"
              placeholder="Nº"
              formValue="nuNumero"
              defaultValue={supplierData?.nuNumero}
              maxLength={10}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Complemento"
              placeholder="Complemento"
              formValue="txComplemento"
              defaultValue={
                supplierData?.txComplemento === null
                  ? ''
                  : supplierData?.txComplemento
              }
              maxLength={50}
            />
            <Input
              control={control}
              errors={errors}
              label="Cidade"
              placeholder="Cidade"
              formValue="txCidade"
              defaultValue={supplierData?.txCidade}
              maxLength={50}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Estado"
              placeholder="UF"
              formValue="sgEstado"
              defaultValue={supplierData?.sgEstado}
              maxLength={2}
              required
            />
          </Grid>

          <Grid
            gridCols="2.5fr 1fr 1fr 2fr 1fr 0.5fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Bairro"
              placeholder="Bairro"
              formValue="txBairro"
              defaultValue={supplierData?.txBairro}
              maxLength={50}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Telefone"
              placeholder="+000 (00) 0000-0000"
              formValue="nuTelefone"
              mask={["#############"]}
              maxLength={13}
              defaultValue={
                supplierData?.nuTelefone === null
                  ? ''
                  : supplierData?.nuTelefone
              }
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Celular"
              placeholder="+000 (00) 0000-0000"
              mask={["#############"]}
              maxLength={13}
              formValue="nuCelular"
              defaultValue={
                supplierData?.nuCelular === null ? '' : supplierData?.nuCelular
              }
            />
            <Input
              control={control}
              errors={errors}
              label="País"
              placeholder="País"
              formValue="sgPais"
              defaultValue={supplierData?.sgPais}
              maxLength={2}
              required
            />
          </Grid>

          <Span
            text="RESPONSÁVEL PELA EMPRESA"
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
          <Grid
            gridCols="2.5fr 1fr 3fr 1.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <InputMask
              control={control}
              errors={errors}
              type="letter"
              label="Nome"
              placeholder="Nome Completo"
              formValue="nmResponsavel"
              defaultValue={supplierData?.nmResponsavel}
              maxLength={50}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="CPF / Passaporte"
              placeholder="Nº"
              formValue="cdCpfResponsavel"
              defaultValue={supplierData?.cdCpfResponsavel}
              mask={
                isNaN(parseInt(responsibleDoc))
                  ? ['NN##########']
                  : ['###.###.###-##']
              }
              required
            />
            <Input
              control={control}
              errors={errors}
              label="E-mail"
              placeholder="Endereço de E-mail"
              formValue="txEmailResponsavel"
              defaultValue={supplierData?.txEmailResponsavel}
              maxLength={50}
              required
            />
            <Input
              control={control}
              errors={errors}
              label="Contato"
              placeholder="(00) 00000-0000"
              mask={["#############"]}
              maxLength={13}
              formValue="nuCelResponsavel"
              defaultValue={
                supplierData?.nuCelResponsavel === null
                  ? ''
                  : supplierData?.nuCelResponsavel
              }
              required
            />
          </Grid>

          <Span
            text="COMERCIAL"
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
          <>
            {businessContacts
              ? businessContacts.length == 0
                ? setBusinessContacts([
                  {
                    cdTipo: 'Comercial',
                    idFornecedorContato: 0,
                    nmContato: '',
                    txEmail: ''
                  }
                ])
                : null
              : null}
            {businessContacts?.map((businessContact, index) => (
              <Grid
                key={index}
                gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
                gridGap={`0 ${SPACING.spacing15}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  label="Contato"
                  placeholder="Contato"
                  value={businessContact?.nmContato}
                  // onChange={(e) => handleChangeBusinessContact(e, index)}
                  onChange={(e) => {
                    if (isValidValue(e)) {
                      handleChange('contatosComercial', 'nmContato', e, index)
                    }
                  }}
                  maxLength={50}
                  customError={error('contatosComercial', 'nmContato', index)}
                />
                <Input
                  label="E-mail"
                  placeholder="Endereço de E-mail"
                  value={businessContact?.txEmail}
                  name={`businessContact${index}`}
                  // onChange={(e) => handleChangeBusinessEmail(e, index)}
                  onChange={(e) =>
                    handleChange('contatosComercial', 'txEmail', e, index)
                  }
                  maxLength={50}
                  customError={error('contatosComercial', 'txEmail', index)}
                />
                <Button text="+" onClick={() => addBusinessContact()} />
                <Button
                  text="-"
                  onClick={() =>
                    handleConfirmDeleteContact(
                      businessContact?.idFornecedorContato,
                      index,
                      'business'
                    )
                  }
                />
              </Grid>
            ))}
          </>

          <Span
            text="DOCUMENTAÇÃO TRABALHISTA"
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
          <>
            {workContacts
              ? workContacts.length == 0
                ? setWorkContacts([
                  {
                    cdTipo: 'Trabalhista',
                    idFornecedorContato: 0,
                    nmContato: '',
                    txEmail: ''
                  }
                ])
                : null
              : null}
            {workContacts?.map((workContact, index) => (
              <Grid
                key={index}
                gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
                gridGap={`0 ${SPACING.spacing15}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  label="Contato"
                  placeholder="Contato"
                  value={workContact.nmContato}
                  // onChange={(e) => handleChangeWorkContact(e, index)}
                  onChange={(e) => {
                    if (isValidValue(e)) {
                      handleChange('contatosTrabalhista', 'nmContato', e, index)
                    }
                  }}
                  maxLength={50}
                  customError={error('contatosTrabalhista', 'nmContato', index)}
                />
                <Input
                  label="E-mail"
                  placeholder="Endereço de E-mail"
                  value={workContact.txEmail}
                  // onChange={(e) => handleChangeWorkEmail(e, index)}
                  onChange={(e) =>
                    handleChange('contatosTrabalhista', 'txEmail', e, index)
                  }
                  maxLength={50}
                  customError={error('contatosTrabalhista', 'txEmail', index)}
                />
                <Button text="+" onClick={() => addWorkContact()} />
                <Button
                  text="-"
                  onClick={() =>
                    handleConfirmDeleteContact(
                      workContact?.idFornecedorContato,
                      index,
                      'work'
                    )
                  }
                />
              </Grid>
            ))}
          </>

          <Span
            text="SEGURANÇA"
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
          <>
            {securityContacts
              ? securityContacts.length == 0
                ? setSecurityContacts([
                  {
                    cdTipo: 'Seguranca',
                    idFornecedorContato: 0,
                    nmContato: '',
                    txEmail: ''
                  }
                ])
                : null
              : null}
            {securityContacts?.map((securityContact, index) => (
              <Grid
                key={index}
                gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
                gridGap={`0 ${SPACING.spacing15}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  label="Contato"
                  placeholder="Contato"
                  value={securityContact.nmContato}
                  // onChange={(e) => handleChangeSecurityContact(e, index)}
                  onChange={(e) => {
                    if (isValidValue(e)) {
                      handleChange('contatosSeguranca', 'nmContato', e, index)
                    }
                  }}
                  maxLength={50}
                  customError={error('contatosSeguranca', 'nmContato', index)}
                />
                <Input
                  label="E-mail"
                  placeholder="Endereço de E-mail"
                  value={securityContact.txEmail}
                  // onChange={(e) => handleChangeSecurityEmail(e, index)}
                  onChange={(e) =>
                    handleChange('contatosSeguranca', 'txEmail', e, index)
                  }
                  maxLength={50}
                  customError={error('contatosSeguranca', 'txEmail', index)}
                />
                <Button text="+" onClick={() => addSecurityContact()} />
                <Button
                  text="-"
                  onClick={() =>
                    handleConfirmDeleteContact(
                      securityContact?.idFornecedorContato,
                      index,
                      'security'
                    )
                  }
                />
              </Grid>
            ))}
          </>

          <Span
            text="IMPORTAÇÃO"
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
          <>
            {importContacts
              ? importContacts.length == 0
                ? setImportContacts([
                  {
                    cdTipo: 'Importacao',
                    idFornecedorContato: 0,
                    nmContato: '',
                    txEmail: ''
                  }
                ])
                : null
              : null}
            {importContacts?.map((importContact, index) => (
              <Grid
                key={index}
                gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
                gridGap={`0 ${SPACING.spacing15}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  label="Contato"
                  placeholder="Contato"
                  value={importContact.nmContato}
                  // onChange={(e) => handleChangeImportContact(e, index)}
                  onChange={(e) => {
                    if (isValidValue(e)) {
                      handleChange('contatosImportacao', 'nmContato', e, index)
                    }
                  }}
                  maxLength={50}
                  customError={error('contatosImportacao', 'nmContato', index)}
                />
                <Input
                  label="E-mail"
                  placeholder="Endereço de E-mail"
                  value={importContact.txEmail}
                  // onChange={(e) => handleChangeImportEmail(e, index)}
                  onChange={(e) =>
                    handleChange('contatosImportacao', 'txEmail', e, index)
                  }
                  maxLength={50}
                  customError={error('contatosImportacao', 'txEmail', index)}
                />
                <Button text="+" onClick={() => addImportContact()} />
                <Button
                  text="-"
                  onClick={() => {
                    handleConfirmDeleteContact(
                      importContact?.idFornecedorContato,
                      index,
                      'import'
                    )
                  }}
                />
              </Grid>
            ))}
          </>
          <SuccessModal
            open={deleteModalOpen}
            message="Confirma exclusão (S/N)?"
            type="alert"
            txtButtonCancel="NÃO"
            txtButtonConfirm="SIM"
            handleCancel={() => SetDeleteModalOpen(false)}
            handleConfirm={handleDeleteContact}
          />
          <SuccessModal
            open={loading === 'error'}
            message={msgErro}
            type="error"
            hideButtonCancel
            handleConfirm={() => setLoading('idle')}
            txtButtonConfirm="Voltar"
          />
        </DialogContentStyled>

        <DialogActionsStyled>
          {/* <Button
            text="Enviar E-mail"
            variantButton="text"
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing20}
            onClick={handleReEnviarEmail}
          /> */}
          <Button
            text="Voltar"
            variantButton="outlined"
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing20}
            onClick={() => {
              toggleModal()
              reset()
              resetModalState(draggableReference)
              // Reseta campos de contatos não salvos ao voltar,
              // tava permanecendo o valor ao clicar em "Voltar"
              // no menu de edição e depois editar o mesmo item!
              resetContactsList()
            }}
          />
          <Button
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing20}
            text="Salvar"
            type="submit"
          />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default SupplierRecordModal
